import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthContext";
import { NotFound } from "../pages/NotFound";

/**
 * Who can see the Capacity page while it is being tried out: one person, by
 * work email, until it has earned a wider audience.
 *
 * Presentation only, and deliberately so: the page computes from
 * /api/requests and /api/team, which every staff member can already read, so
 * there is no new data to protect — only a screen to keep out of the way.
 * Widen this list, or delete the gate, when the trial is over.
 */
export const CAPACITY_PILOTS = ["lucas@eulerapp.com"];

export function useIsPilot(): boolean {
  const { user } = useAuth();
  return user?.email !== undefined && CAPACITY_PILOTS.includes(user.email.toLowerCase());
}

/** Hides a control from everyone but the pilots. */
export function PilotOnly({ children }: { children: ReactNode }) {
  return useIsPilot() ? <>{children}</> : null;
}

/** Refuses the route to everyone but the pilots — a typed URL gets the same
 *  "doesn't lead anywhere" as a page that does not exist. */
export function RequirePilot({ children }: { children: ReactNode }) {
  return useIsPilot() ? <>{children}</> : <NotFound />;
}
